import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class DataProcess extends Base {
  /**
   * @description Machine Health
   * @returns {Promise<Response>}
   */
  overallHealth(model, payload) {
    const url = this._getFullURL(`/data-process/health/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Machine Health
   * @returns {Promise<Response>}
   */
  machineHealth(model, payload) {
    const url = this._getFullURL(`/data-process/machine-health/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Machine Health
   * @returns {Promise<Response>}
   */
  machineHealthAll(model, payload) {
    const url = this._getFullURL(`/data-process/machine-health-all/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Machine Health
   * @returns {Promise<Response>}
   */
  machineHealthAllQuery(model, payload) {
    const url = this._getFullURL(
      `/data-process/machine-health-filter/${model}`
    );
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Machine Uptime
   * @returns {Promise<Response>}
   */
  overallUptime(model, payload) {
    const url = this._getFullURL(`/data-process/uptime/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Machine Uptime
   * @returns {Promise<Response>}
   */
  uptimePerMachine(model, payload) {
    const url = this._getFullURL(`/data-process/machineUptime/uptime`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Machine Uptime
   * @returns {Promise<Response>}
   */
  onlinePerMachine(model, payload) {
    const url = this._getFullURL(`/data-process/machineOnline/online`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Most Critical
   * @returns {Promise<Response>}
   */
  mostCritical(model, payload) {
    const url = this._getFullURL(`/data-process/critical/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Most Critical
   * @returns {Promise<Response>}
   */
  lowestHealth(model, payload) {
    const url = this._getFullURL(`/data-process/lowestHealth/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Alert Counr
   * @returns {Promise<Response>}
   */
  alertCount(model, payload) {
    const url = this._getFullURL(`/data-process/alertsCount/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Alert Counr
   * @returns {Promise<Response>}
   */
  mostNumber(model, payload) {
    const url = this._getFullURL(`/data-process/most-number-alert/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Alert Counr
   * @returns {Promise<Response>}
   */
  healthPerLocation(model, payload) {
    const url = this._getFullURL(
      `/data-process/machine-health-per-location/${model}`
    );
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Alert Count Per Machine
   * @returns {Promise<Response>}
   */
  alertCountPerMachine(model, payload) {
    const url = this._getFullURL(
      `/data-process/alertsCountPerMachine/${model}`
    );
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Alert Count Per Machine
   * @returns {Promise<Response>}
   */
  generateReport(model, payload) {
    const url = this._getFullURL(`/data-process/reportMaker/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
  /**
   * @description Machine Health permachine
   * @returns {Promise<Response>}
   */
  machineHealtSublocation(model, payload) {
    const url = this._getFullURL(`/data-process/health-all-machine/${model}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload,
        method: "POST",
      })
    );
  }
}
